import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { SchoolPicker } from '../school-picker/school-picker';
import { NgOptimizedImage } from '@angular/common';
import { AuthService } from '../../auth/services/auth.service';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatDivider } from '@angular/material/divider';
import { ChangePasswordDialog } from '../../auth/change-password-dialog/change-password-dialog';
import { EditProfileDialog } from '../../auth/edit-profile-dialog/edit-profile-dialog';
import { ChangeEmailDialog } from '../../auth/change-email-dialog/change-email-dialog';
import { UserRolePipe } from '../pipes/UserRolePipe';

@Component({
  selector: 'app-navigation',
  imports: [
    RouterLink,
    RouterLinkActive,
    SchoolPicker,
    NgOptimizedImage,
    MatButtonModule,
    MatIcon,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    MatDivider,
    UserRolePipe,
  ],
  templateUrl: './navigation.html',
})
export class Navigation {
  readonly authService = inject(AuthService);
  private readonly dialog = inject(MatDialog);

  openEditProfileDialog(): void {
    this.dialog.open(EditProfileDialog, this.dialogConfig);
  }

  openChangeEmailDialog(): void {
    this.dialog.open(ChangeEmailDialog, this.dialogConfig);
  }

  openChangePasswordDialog(): void {
    this.dialog.open(ChangePasswordDialog, this.dialogConfig);
  }

  private readonly dialogConfig = {
    width: '480px',
    autoFocus: 'first-tabbable',
    restoreFocus: false,
  } as const;
}
